$flagHeight: 15px !default;
$flagWidth: 20px !default;
$flagPadding: 8px !default;

@use '../../../../../node_modules/intl-tel-input/src/css/sprite.scss';

:host {
  display: block;
}
.iti__flag {
  height: $flagHeight;
  box-shadow: 0px 0px var(--p-size-static-0125) 0px var(--s-color-border-default);
  background-repeat: no-repeat;
  // empty state
  background-color: var(--b-color-neutral-default);
  background-position: $flagWidth 0;
  background-size: 5652px 15px;
}

.anchor-c-country-code {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  color: var(--text-color);
  gap: var(--p-size-static-100);

  .iti__dial-code {
    min-width: 42px;
    color: var(--text-color);
  }
  .iti__flag-box,
  .iti__country-name {
    margin-right: 0;
  }
}
